module.exports = __webpack_public_path__ + "static/img/-s-icon geren.af944130.svg";